import { Dialog, DialogContent } from "@/components/ui/dialog";

interface Props {
  url: string | null;
  name: string;
  onClose: () => void;
}

export function ProfilePhotoViewer({ url, name, onClose }: Props) {
  return (
    <Dialog open={!!url} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="flex items-center justify-center p-2 sm:p-4 max-w-xs sm:max-w-sm md:max-w-md bg-transparent border-0 shadow-none [&>button]:text-white [&>button]:bg-black/40 [&>button]:rounded-full [&>button]:p-1">
        <img
          src={url!}
          alt={name}
          className="w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl"
        />
      </DialogContent>
    </Dialog>
  );
}
